import React, { useState, useEffect } from "react";
import "./internshipPageContent.css";

const InternshipPageContent = () => {
  const [activeTab, setActiveTab] = useState("internshipApplication");
  const [tableData, setTableData] = useState([]);
  const [internShipList, setInternShipList] = useState([]);
  const [paymentHistory, setPaymentHistory] = useState([]);

  const fetchInternshipData = async () => {
    try {
      const response = await fetch("https://admindashboard.clns.in/api/st_adv/dashboard_internship_get/");
      const data = await response.json();
      if (data.status) {
        setTableData(data.data || []);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching internship data:", error);
    }
  };

  const fetchInternshipList = async () => {
    try {
      const response = await fetch("https://admindashboard.clns.in/api/st_adv/internship_list/");
      const data = await response.json();
      if (data.status) {
        setInternShipList(data.data || []);
        setPaymentHistory(data.data || []);
      } else {
        setInternShipList([]);
        setPaymentHistory([]);
      }
    } catch (error) {
      console.error("Error fetching internship list:", error);
    }
  };

  const handleStatusChange = async (internshipId, status) => {
    try {
      const payload = { internship_id: internshipId, status };
      const response = await fetch("https://admindashboard.clns.in/api/st_adv/dashboard_internship_get/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result.status) {
        alert(`Internship status updated to ${status}`);
        fetchInternshipData();
        fetchInternshipList();
      } else {
        alert("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating internship status:", error);
    }
  };

  const handleEndInternship = async (internshipId) => {
    try {
      const payload = { internship_id: internshipId };
      const response = await fetch("https://admindashboard.clns.in/api/st_adv/internship_list/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result.status) {
        alert("Internship marked as completed.");
        fetchInternshipList();
      } else {
        alert("Failed to mark internship as completed.");
      }
    } catch (error) {
      console.error("Error ending internship:", error);
    }
  };

  const isInternshipCompleted = (status) => status === "completed";

  // New method to redirect to S3 link
  const redirectToResume = (rawUrl) => {
    if (!rawUrl) return;

    try {
      // Clean up the URL by removing any leading slash and decoding
      const cleanedUrl = rawUrl.startsWith("/") ? rawUrl.slice(1) : rawUrl;
      const decodedUrl = decodeURIComponent(cleanedUrl);
      
      // Redirect to the S3 link (this will open the link in a new tab)
      console.log(decodedUrl)
      window.open(decodedUrl, "_blank");
    } catch (err) {
      console.error("Failed to redirect to the resume:", err);
    }
  };

  useEffect(() => {
    fetchInternshipData();
    fetchInternshipList();
  }, []);

  return (
    <div className="internshipContainer">
      {/* Tabs */}
      <div className="tabContainer">
        <button
          className={activeTab === "internshipApplication" ? "active" : ""}
          onClick={() => setActiveTab("internshipApplication")}
        >
          Internship Application
        </button>
        <button
          className={activeTab === "internshipList" ? "active" : ""}
          onClick={() => setActiveTab("internshipList")}
        >
          Internship List
        </button>
        <button
          className={activeTab === "internshipPayment" ? "active" : ""}
          onClick={() => setActiveTab("internshipPayment")}
        >
          Internship Payment History
        </button>
      </div>

      {/* Tab Content */}
      <div className="content">
        {activeTab === "internshipApplication" && (
          <div>
            {tableData.length > 0 ? (
              <table>
                <thead>
                  <tr>
                    <th>Student Name</th>
                    <th>Lawyer Name</th>
                    <th>S Location</th>
                    <th>L Location</th>
                    <th>S Phoneno.</th>
                    <th>L Phoneno.</th>
                    <th>Resume</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={index}>
                      <td>{row.student_name}</td>
                      <td>{row.advocate_name}</td>
                      <td>{row.student_location}</td>
                      <td>{row.advocate_location}</td>
                      <td>{row.student_mobile_num}</td>
                      <td>{row.advocate_mobile_num}</td>
                      <td>
                        {row.student_resume ? (
                          <button onClick={() => redirectToResume(row.student_resume)}>
                            View Resume
                          </button>
                        ) : (
                          "No Resume"
                        )}
                      </td>
                      <td>{row.application_date}</td>
                      <td>
                        <button
                          className="acceptButton"
                          onClick={() => handleStatusChange(row.internship_id, "approved")}
                        >
                          Approve
                        </button>
                        <button
                          className="declineButton"
                          onClick={() => handleStatusChange(row.internship_id, "rejected")}
                        >
                          Decline
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No approved internships found.</p>
            )}
          </div>
        )}

        {activeTab === "internshipList" && (
          <div>
            {internShipList.length > 0 ? (
              <table>
                <thead>
                  <tr>
                    <th>Student Name</th>
                    <th>Lawyer Name</th>
                    <th>S Location</th>
                    <th>L Location</th>
                    <th>S Phoneno.</th>
                    <th>L Phoneno.</th>
                    <th>S Date</th>
                    <th>E Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {internShipList.map((row, index) => (
                    <tr key={index}>
                      <td>{row.student_name}</td>
                      <td>{row.advocate_name}</td>
                      <td>{row.student_location}</td>
                      <td>{row.advocate_location}</td>
                      <td>{row.student_mobile_num}</td>
                      <td>{row.advocate_mobile_num}</td>
                      <td>{row.start_date}</td>
                      <td>{row.end_date}</td>
                      <td>
                        <button
                          className="endButton"
                          onClick={() => handleEndInternship(row.internship_id)}
                          disabled={isInternshipCompleted(row.status)}
                        >
                          End
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No active internships found.</p>
            )}
          </div>
        )}

        {activeTab === "internshipPayment" && (
          <div>
            {paymentHistory.length > 0 ? (
              <table>
                <thead>
                  <tr>
                    <th>Student Name</th>
                    <th>Location</th>
                    <th>Phoneno.</th>
                    <th>Email</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentHistory.map((row, index) => (
                    <tr key={index}>
                      <td>{row.student_name}</td>
                      <td>{row.student_location}</td>
                      <td>{row.student_mobile_num}</td>
                      <td>{row.student_email}</td>
                      <td>{row.start_date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No payment history found.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default InternshipPageContent;
